module.exports = __webpack_public_path__ + "assets/images/new-amira-small.ee9721d1b4fe80461398952bd0c75405.svg";